<template>
  <v-text-field
    label="Händelserubrik"
    hint="Obligatorisk"
    persistent-hint
    outlined
    :disabled="disabled"
    v-model="title"
    :rules="[required]"
  />
</template>

<script>
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'

export default {
  name: 'EventTitleField',

  props: {
    disabled: Boolean
  },

  data: () => ({
    required
  }),

  computed: {
    title: sync('event/model@title')
  }
}
</script>
